"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandlerInstance = void 0;
/**
 * Provides a convenient wrapper around putting async message handlers inside a class
 * object that may have instance data.
 *
 * NOTE: due to the nature of handler registration and enumerable properties on classes, MAKE SURE
 * you use the bind syntax for creating methods so the instance is correctly found and bound.
 * If you use a normal class method syntax, your method will not be found and "this" will not be
 * your class instance.
 *
 * DO THIS:
 *     class Correct extends HandlerInstance {
 *       correctHandler = async (params: MyParams) => { ... };
 *     }
 *
 * DO NOT DO THIS:
 *     class WRONG extends HandlerInstance {
 *       async wrongHandler(params: MyWrongParams) { ... }
 *     }
 */
class HandlerInstance {
    constructor() {
        /** Contains the communicator instance that this class instance is registered with. */
        this.communicator = null;
        /** Contains a list of method names to ignore. Feel free to add to this if needed. */
        this.ignoreMethods = ['getHandlers', 'setAsyncMessageCommunicator'];
    }
    /**
     * Returns all of the instance methods for this implementation, excluding the
     * utility functions listed in {@see ignoreMethods} or functions starting with
     * an underscore.
     * @returns {Record<string, Handler>} returns an object mapping
     */
    getHandlers() {
        const handlers = {};
        for (const [k, v] of Object.entries(this)) {
            if (v instanceof Function && !this.ignoreMethods.includes(k) && !k.startsWith('_')) {
                handlers[k] = v;
            }
        }
        return handlers;
    }
    /** Sets the communicator for this instance. */
    setAsyncMessageCommunicator(communicator) {
        this.communicator = communicator;
    }
}
exports.HandlerInstance = HandlerInstance;
//# sourceMappingURL=HandlerInstance.js.map